module.exports = __webpack_public_path__ + "img/blog1.91054213.jpeg";